// Google Analytics 4 helper functions

export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Specific game event trackers
export const trackGuessSubmitted = (isCorrect, isOneAway, numGuesses) => {
  trackEvent('guess_submitted', {
    correct: isCorrect,
    one_away: isOneAway,
    guess_number: numGuesses,
  });
};

export const trackRepeatedGuess = () => {
  trackEvent('repeated_guess');
};

export const trackGameWon = (numGuesses, numMistakes) => {
  trackEvent('game_won', {
    num_guesses: numGuesses,
    num_mistakes: numMistakes,
    success: true,
  });
};

export const trackGameLost = (numGuesses, numMistakes) => {
  trackEvent('game_lost', {
    num_guesses: numGuesses,
    num_mistakes: numMistakes,
    success: false,
  });
};

export const trackShuffle = () => {
  trackEvent('shuffle_clicked');
};

export const trackDeselect = () => {
  trackEvent('deselect_clicked');
};

export const trackShareScore = (numGuesses, won) => {
  trackEvent('share_score', {
    num_guesses: numGuesses,
    won: won,
  });
};

export const trackWordSelected = (word, isSelecting) => {
  trackEvent('word_clicked', {
    word: word,
    action: isSelecting ? 'select' : 'deselect',
  });
};

export const trackPlayAgain = () => {
  trackEvent('play_again_clicked');
};

export const trackViewResults = () => {
  trackEvent('view_results_clicked');
};

export const trackInfoModalOpened = () => {
  trackEvent('info_modal_opened');
};
